import React from "react"
import { StyledTextArea } from "./style"

const TextArea = (props: any) => {
  return <StyledTextArea {...props} />
}

export default TextArea
